<template>
  <div
    class="animate-pulse flex flex-nowrap overflow-auto rtl:space-x-reverse space-x-4 lg:flex-wrap lg:grid lg:grid-cols-2 lg:space-x-0 lg:gap-4"
  >
    <div
      v-for="n in 4"
      :key="`shimmer-${n}`"
      class="w-80 h-80 flex-shrink-0 bg-shimmer rounded lg:w-full lg:h-full"
    >
      <div class="hidden lg:block aspect-w-1 aspect-h-1 dark:bg-gray-850"></div>
    </div>
  </div>
</template>
